import { Model, Attrs } from 'ng2-app/modules/shared/models/model.class';
import { Comment } from 'ng2-app/modules/comment/models/comment/comment.model';
import * as _ from 'lodash';

/**
 * Activity class
 *
 * Only lists attributes for base activity.
 *
 * Please please do not add type specific attributes as optional attributes. There has to be a better way. Thanks.
 */
export class Activity extends Model<Activity> {

    // common attributes
    id: number;
    type: string;
    subType: string;
    lenderId: number;
    lenderUserId: number;
    borrowerId: number;
    borrowerName: string;
    dealId: number;
    stage: string;
    oldStage: string;
    status: string;
    oldStatus: string;
    createdTimestamp: number; // use this to be timezone safe
    modifiedTimestamp: number; // use this to be timezone safe
    deletedTimestamp: number|null;
    comments: Comment[];

    // type specific attributes
    // TODO figure out how to define each type properly
    meta: {[key: string]: any};

    constructor(props?: Attrs) {
        super(props);

        this.comments = this.prepareComments(props);
        this.cleanRecipients();
    }

    fillable(): string[] {
        return [
            'id',
            'type',
            'subType',
            'lenderId',
            'lenderUserId',
            'borrowerId',
            'borrowerName',
            'dealId',
            'stage',
            'oldStage',
            'status',
            'oldStatus',
            'createdTimestamp',
            'modifiedTimestamp',
            'deletedTimestamp',
            'meta',
            'comments'
        ];
    }

    serializeable(): string[] {
        return this.fillable();
    }

    private prepareComments(props): Comment[] {
        const comments = _.get(props, 'comments', []) as Comment[] | {[key: string]: Comment};

        return _(comments)
            .values()
            .map((attrs: any) => new Comment(attrs))
            .reject((attrs: any) => attrs.deleted)
            .value();
    }

    private cleanRecipients() {
        if (this.type !== 'message' || Array.isArray(this.meta.recipients)) {
            return;
        }
        this.meta.recipients = [];
    }
}
